import React, { createContext, useState } from 'react';
import { TypeSetState } from '../global';
import { GameInterface, gameInterfaceDefault } from '../settings/interface';

interface GameInterfaceProviderProps {
	children: React.ReactNode;
}

interface IGameInterfaceProvider {
	gameInterface: GameInterface,
	setGameInterface: TypeSetState<GameInterface>
}

const defaultContext: IGameInterfaceProvider = {
	gameInterface: gameInterfaceDefault,
	setGameInterface: () => {}
};
export const GameInterfaceContext: React.Context<IGameInterfaceProvider> = createContext(defaultContext);

export const GameInterfaceProvider = ({ children }: GameInterfaceProviderProps) => {
	const [gameInterface, setGameInterface] = useState(defaultContext.gameInterface);
	return <GameInterfaceContext.Provider
		value={{
			gameInterface,
			setGameInterface
		}}> {children}</GameInterfaceContext.Provider>;

};